/**
 * Using Object.prototype.toString.call() works much than typeof for type checking in JavaScript, since it works
 * properly for null. Not only that, but it returns the specific type of any given object.
 */
export const ofClass = (className) => (obj) => Object.prototype.toString.call(obj) === `[object ${className}]`;
